import { CommercialPlatformDto } from '@/models/CommercialPlatformDTO.model';
import ApiService from '@/services/Api.service';

export class CommercialPlatformService {
  static async getAll(
    excludeStateProgram?: boolean
  ): Promise<CommercialPlatformDto[]> {
    return await ApiService.getJson<CommercialPlatformDto[]>(
      '/commercial-platforms',
      { excludeStateProgram }
    );
  }

  static async getById(
    commercialPlatformId: number
  ): Promise<CommercialPlatformDto> {
    return await ApiService.getJson<CommercialPlatformDto>(
      `/commercial-platforms/${commercialPlatformId}`
    );
  }
}
